'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dependencies = require('../dependencies');

var _helpers = require('../../../helpers');

var _selectors = require('../services/selectors');

var translatable = function translatable(intlLocaleData, antdLocaleData) {
  return function (TranslatableComponent) {
    var Component = function Component(props) {
      return _dependencies.React.createElement(_dependencies.IntlProvider, {
        locale: props.locale,
        key: props.locale,
        messages: intlLocaleData[props.locale]
      }, _dependencies.React.createElement(_dependencies.LocaleProvider, {
        locale: antdLocaleData[props.locale]
      }, _dependencies.React.createElement(TranslatableComponent, props)));
    };

    Component.displayName = 'Translatable(' + (0, _helpers.getDisplayName)(TranslatableComponent) + ')';
    Component.propTypes = {
      locale: _dependencies.PropTypes.string.isRequired
    };
    return (0, _dependencies.connect)(function (state) {
      return (0, _selectors.translateSelector)(state);
    })(Component);
  };
};

exports.default = translatable;